import Card from '@/components/UI/Card';
import { formatEnumLabel, formatMetric, getEventTone } from './helpers';
import type { ObvAuditEventRow } from './types';

interface FilteredEventTimelineCardProps {
    filteredEvents: ObvAuditEventRow[];
    onFocusEvent: (dateTime: string) => void;
    selectedDateTime: string | null;
}

const FilteredEventTimelineCard = ({ filteredEvents, onFocusEvent, selectedDateTime }: FilteredEventTimelineCardProps) => (
    <Card responsivePadding bodyClassName="space-y-4" title="Filtered Event Timeline">
        {filteredEvents.length === 0 ? (
            <div className="text-sm text-zinc-400">No OBV events match the current event-type filters.</div>
        ) : (
            <div className="max-h-[820px] space-y-2 overflow-y-auto pr-1">
                {filteredEvents.map((eventRow) => {
                    const isFocused = selectedDateTime === eventRow.dateTime;

                    return (
                        <button
                            className={`w-full rounded-lg border px-3 py-3 text-left transition-colors ${
                                isFocused ? 'border-blue-500 bg-blue-500/10' : 'border-zinc-800 bg-zinc-950/70 hover:bg-zinc-900'
                            }`}
                            key={`${eventRow.dateTime}:${eventRow.event.type}:${eventRow.event.barIndex}`}
                            type="button"
                            onClick={() => onFocusEvent(eventRow.dateTime)}
                        >
                            <div className="flex items-center justify-between gap-3">
                                <div className="font-medium text-zinc-100">{formatEnumLabel(eventRow.event.type)}</div>
                                <div className="text-xs text-zinc-500">{eventRow.dateTime}</div>
                            </div>
                            <div className="mt-2 text-xs text-zinc-400">
                                tone={getEventTone(eventRow.event)} · flow20=
                                {formatMetric(eventRow.event.flowBalance20, 3)} · signal=
                                {formatMetric(eventRow.event.signalDistance, 3)}
                            </div>
                        </button>
                    );
                })}
            </div>
        )}
    </Card>
);

export default FilteredEventTimelineCard;
